import { t } from 'i18next';
import * as ClaimService from '../../Services/claim-service';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { warning } from '../../Components/custom-toast/CustomToast';
function ClaimRequestTermSubmit({ objectDto, setObjectDto, setLoading, term, setTerm, setValidate, listFile, setOpen }) {
    return (
        <>
            <div id="assured" style={{ display: objectDto.checked === 6 && objectDto.checkSumAssured !== undefined && objectDto.checkSumAssured === 0 ? "block" : "none" }}>
                <div data-toggle="collapse" data-target="#search-box-6-2" className="header-box">
                    <h2 className="title-box description-large-customer"> {t("claimassured").toUpperCase()}</h2>
                </div>
                <div className={"collapse in"} id="search-box-6-2">
                    <div className="border-box-sc row">
                        <div className="col-md-12 ">
                            <div className="form-group col-md-12">
                                <div className="col-md-12 description-small-customer">
                                    <ul>
                                        <li><span>{t("claimassured1") + ' '}</span></li>
                                        <li>
                                            <FormControlLabel label={<Typography sx={{ typography: { sm: 'h6', xs: 'body2' }, color: "black" }}>{t('claimassured')}</Typography>}
                                                control={<Checkbox id="term" name="term" checked={term} className='iCheck-checkbox' label={""}
                                                    onChange={(e) => ClaimService.onTermChange(e, setTerm, setObjectDto, objectDto)}
                                                    sx={{ color: "black", "&.Mui-checked": { color: "#c4960c", }, "& .MuiSvgIcon-root": { fontSize: 20 } }} />}
                                                sx={{ "& .MuiFormControlLabel-label": { fontSize: "13px", fontWeight: "normal" }, margin: "-10px 0px -10px -10px" }}
                                            />
                                        </li>
                                        <li>
                                            <i className="fa fa-ellipsis-h" aria-hidden="true" /><span>{t("claimassured2") + " "}</span>
                                        </li>
                                        <li>
                                            <i className="fa fa-ellipsis-h" aria-hidden="true" /><span>{t("claimassured3") + " "}</span>
                                        </li>
                                        <li>
                                            <i className="fa fa-ellipsis-h" aria-hidden="true" /><span>{t("claimassured4") + " "}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-box-bg col-md-12 form-group" style={{ color: "red", display: "none", textAlign: "center" }} id="warning">
                <span>
                    Hệ thống đang cập nhật dữ liệu, vui lòng KHÔNG tắt trình duyệt
                    hoặc refresh lại trang.
                </span>
            </div>
            <div className="bg-content btn-green" id="" style={{ display: objectDto.saved === 1 && objectDto.checkSumAssured === 0 ? "block" : "none" }}>
                <div className="collapse in" id="search-box-7">
                    <div className="border-box-sc row">
                        <div className="col-md-12 ">
                            <div className="form-group col-md-12">
                                <div className="col-md-12 description-small-customer" style={{ textAlign: "center" }}>
                                    <ul>
                                        <li><i className="fa fa-check-circle" aria-hidden="true" style={{ fontSize: 50 }} />{" "}</li>
                                        <li>
                                            <span> Cảm ơn Quý khách đã tin cậy và đồng hành cùng Công ty Bảo hiểm nhân thọ Phú Hưng. Quý khách đã thao tác
                                                thành công bước nộp hồ sơ yêu cầu giải quyết QLBH trực tuyến. Quý khách sẽ nhận được phản hồi qua
                                                email/SMS các bước xử lý hồ sơ sau 1 ngày làm việc
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* submit Div	 */}
            <div className="footer-box-bg col-md-6 col-sm-6 col-xs-4 form-group" style={{ display: objectDto.checked > 0 && objectDto.saved === 0 ? "block" : "none", textAlign: "left" }} >
                <a id="btnClose" className="btn-common btn-search description-small-customer" href onClick={() => {
                    sessionStorage.removeItem("sessionId");
                    console.log('aaa')
                    ClaimService.loadInit(setObjectDto);
                }}>
                    <i className="fa fa-file-text" aria-hidden="true" style={{ marginRight: 5 }} />
                    <span>{t("buttonnew")}</span>
                </a>
            </div>
            <div className="footer-box-bg col-md-6 col-sm-6 col-xs-8 form-group" id="submitDiv"
                style={{ display: objectDto.checked > 0 && objectDto.saved === 0 ? "block" : "none" }}>
                <a id="btnPrev" className="btn-common btn-search description-small-customer" href onClick={() => {
                    setLoading(true);
                    ClaimService.HandlePreviousStep(objectDto, setObjectDto, setLoading, setValidate);
                }}>
                    <i className="fa fa-arrow-left" aria-hidden="true" style={{ marginRight: 5 }} />
                    <span>{t("buttonprevious")}</span>
                </a>
                <a id="btnNext" className="btn-common description-small-customer" href style={objectDto.checked === 6 ? { display: "none" } : {}}
                    onClick={() => {
                        setLoading(true);
                        ClaimService.HandleNextStep(objectDto, setObjectDto, setLoading, setValidate, setOpen);
                    }}
                >
                    <span>{t("buttonnext")}</span>
                    <i className="fa fa-arrow-right" aria-hidden="true" style={{ marginLeft: 5 }} />
                </a>
                <a id="btnNext" class="btn-green btn-common description-small-customer" style={!(objectDto.checked === 6 && objectDto.checkSumAssured === 0) ? { display: "none" } : {}}
                    onClick={() => {
                        term === false ?
                            warning(t("pleaseaccept"))
                            :
                            ClaimService.HandleSubmitRequest(objectDto, setObjectDto, listFile, setLoading, setValidate);
                    }}>
                    <span>{t("buttonfinish")}</span>
                    <i class="fa fa-arrow-right" aria-hidden="true" style={{ marginLeft: 5 }} />
                </a>
            </div>
            <div className="footer-box-bg mt-10 form-group" style={{ display: objectDto.saved === 1 ? "block" : "none" }} id="submitDiv">
                <a id="btnClose" className="btn-common btn-search description-small-customer" href onClick={() => {
                    ClaimService.HandleClose(objectDto, setObjectDto);
                }}>
                    <i className="fa fa-ban" aria-hidden="true" style={{ marginRight: 5 }} />
                    <span>{t("buttonclose")}</span>
                </a>
                <a id="btnPrint" className="btn-common btn-search description-small-customer" href onClick={() => {
                    setLoading(true);
                    ClaimService.HandleShowPDF(objectDto, setLoading);
                }}>
                    <span>{t("claimreviewprintpdf")}</span>
                    <i className="fa fa-arrow-right" aria-hidden="true" style={{ marginLeft: 5 }} />
                </a>
            </div>
        </>
    )
}
export default ClaimRequestTermSubmit;